import {Grid, SvgIcon} from "@mui/material";
import TextField from "@mui/material/TextField";
import * as React from "react";
import {findTracks} from "../../http/trackApi";
import {useEffect, useState, useRef, useCallback} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


const TrackSearch = ({onAddTrack, variations})=>{
    const [form, setForm] = useState({
        title: "",
        track: ""
    });
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    // Используем useRef для хранения таймера debounce
    const debounceTimerRef = useRef(null);

    // Функция для поиска треков
    const searchTracks = useCallback(async (searchParams) => {
        if (searchParams.title.length > 2 && searchParams.track.length > 2) {
            try {
                setLoading(true);
                const data = await findTracks(searchParams);

                // console.log(data, variations);
                let filtered = data.filter(item1 =>
                    !variations.some(item2 => {
                        console.log(item1, item2, item2.track === item1.songName, item2.title === item1.singer);
                        return item2.track === item1.songName && item2.title === item1.singer
                    })
                );

                setOptions(filtered);
            } catch (error) {
                console.error("Ошибка при поиске треков:", error);
                setOptions([]);
            } finally {
                setLoading(false);
            }
        } else {
            setOptions([]);
        }
    }, []);

    // Debounce эффект для поиска
    useEffect(() => {
        // Очищаем предыдущий таймер
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }

        // Устанавливаем новый таймер
        debounceTimerRef.current = setTimeout(() => {
            searchTracks(form);
        }, 300);

        // Очистка при размонтировании или изменении form
        return () => {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, [form, searchTracks]);

    const formChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prevState => ({
            ...prevState,
            [name]: type === "checkbox" ? checked : value
        }));
    }

    const handleAddTrack = (track) => {
        console.log("FEEE");
        console.log(track);
        if (onAddTrack) {
            onAddTrack(track);
        }
        // Очищаем поля после добавления
        setForm({ title: "", track: "" });
        setOptions([]);
    }

    // onChange

    console.log(options);

    return (
        <Box
            container
            sx={{marginBottom: 4}}
            position={'relative'}
            style={{
                background: "rgba(171,171,171,0.33)"
            }}
            padding={2}
        >
            <Box
                style={{
                    marginBottom: "10px"
                }}
            >
                <Typography fontWeight={'bold'}>
                    Поиск трека
                </Typography>
            </Box>
            <Grid
                container
                columnSpacing={1}
                display={"flex"}
            >
                <Grid
                    item
                    style={{
                        flex: 1
                    }}
                >
                    <TextField
                        className="login__page__item"
                        label="Исполнитель"
                        variant="outlined"
                        color="secondary"
                        name={"title"}
                        value={form.title}
                        onChange={formChange}
                    />
                </Grid>
                <Grid
                    item
                    style={{
                        flex: 1
                    }}
                >
                    <TextField
                        className="login__page__item"
                        label="Трек"
                        variant="outlined"
                        color="secondary"
                        name={"track"}
                        value={form.track}
                        onChange={formChange}
                    />
                </Grid>
            </Grid>
            {/* Блок с результатами поиска */}
            {(options.length > 0 || loading) && (
                <Box
                    position="absolute"
                    top="100%"
                    left={0}
                    right={0}
                    sx={{
                        backgroundColor: "rgba(18,18,18,0.95)",
                        color: "white",
                        border: "1px solid grey",
                        borderTop: "none",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 1300,
                        borderRadius: "0 0 4px 4px",
                        boxShadow: 3
                    }}
                    p={1}
                >
                    {loading ? (
                        <Box sx={{ p: 2, textAlign: 'center' }}>Загрузка...</Box>
                    ) : (
                        options.map((track, index) => (
                            <Box
                                key={track.id || index}
                                onClick={() => handleAddTrack(track)}
                                sx={{
                                    p: 1.5,
                                    cursor: "pointer",
                                    borderRadius: 1,
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                        backgroundColor: "rgba(255,255,255,0.15)"
                                    },
                                    borderBottom: index < options.length - 1 ? '1px solid rgba(255,255,255,0.1)' : 'none'
                                }}
                            >
                                <Box sx={{ fontWeight: 'bold' }}>{track.songName}</Box>
                                <Box sx={{ fontSize: '0.9rem', opacity: 0.8 }}>{track.singer}</Box>
                            </Box>
                        ))
                    )}
                </Box>
            )}
        </Box>
    )
}

export default TrackSearch;